









































































import Vue from "vue";
import { getIdFromURL } from "vue-youtube-embed";
import PosterUser from "../mixins/poster-user";
import FormContainer from "../mixins/form-container";
import Worker from "@/components/Worker.vue";
import store from "@/store";
import { SimplePosterWithLocales } from "@/store/poster";
import posterService from "@/services/poster";

export interface PosterUploadsComponentData {
  form: {
    url: string;
    file: File | null;
  };
}

store.commit("validation/registerRule", {
  name: "posterFile",
  rule: (f: File): boolean | string => {
    if (!f) {
      return "Campo requerido";
    }

    if (f.size > 10000000) {
      return "El tamaño máximo permitido es de 10 MB";
    }

    if (f.type !== "application/pdf") {
      return "Formato inválido";
    }

    return true;
  },
});

store.commit("validation/registerRule", {
  name: "youtubeURL",
  rule: (url: string): boolean | string => {
    if (typeof url === "string" && getIdFromURL(url).length !== url.length) {
      return true;
    }

    return "La URL no corresponde a un video de YouTube";
  },
});

const PosterUploads = Vue.extend({
  mixins: [PosterUser, FormContainer],
  components: {
    Worker,
  },

  data() {
    return {
      simple: true,
      url: "",
      file: null as File | null,
      dialog_: true,
    };
  },

  watch: {
    value(v: any) {
      if (!v) {
        this.url = "";
        this.file = null;
      }
    },

    sposter(p: SimplePosterWithLocales) {
      if (p) {
        this.url = p.url_video || "";
      }
    },

    visible(v: boolean) {
      if (v) {
        this.$nextTick(() => this.$refs.form.reset());
      }
    },
  },

  methods: {
    async submit() {
      const store = this.$store;
      const { formValidity, sposter } = (this as unknown) as {
        formValidity: any;
        sposter: SimplePosterWithLocales;
      };

      if (!formValidity.uploads || !sposter) {
        return;
      }

      const result: any = await store
        .dispatch("poster/sendPosterUploads", {
          poster: sposter,
          url_video: this.url,
          file: this.file,
        })
        .catch((err: any) => err);

      if (result) {
        (this as any).visible = false;
      }
    },

    onCancel() {
      const source = posterService.uploadCancel;
      if (!source) {
        return;
      }

      source.cancel();
    },
  },
});

export default PosterUploads;
